/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Artic
 * The Artic API documentation
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  BulkCheckStatusDto,
  BulkCheckStatusResponseDto,
  QualityPackCheckRowDto,
  QualityPackListResponseDto,
  QualityPackRowDto,
  QualityPacksControllerListQualityPacksParams,
  QualityPacksControllerResolveByCodeParams,
  ResolveWorkOrderByCodeResponseDto
} from '.././schemas';

import { customFetch } from '../../custom-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Paginated, sorted and tab/date-filtered work-order quality summaries (check counts, last-seen zone/station, completion dates) from the base.quality_packs view. Drives the Quality SPA packs grid.
 * @summary List completed quality packs for a partner
 */
export type qualityPacksControllerListQualityPacksResponse200 = {
  data: QualityPackListResponseDto
  status: 200
}

export type qualityPacksControllerListQualityPacksResponse401 = {
  data: void
  status: 401
}

export type qualityPacksControllerListQualityPacksResponse403 = {
  data: void
  status: 403
}
    
export type qualityPacksControllerListQualityPacksResponseSuccess = (qualityPacksControllerListQualityPacksResponse200) & {
  headers: Headers;
};
export type qualityPacksControllerListQualityPacksResponseError = (qualityPacksControllerListQualityPacksResponse401 | qualityPacksControllerListQualityPacksResponse403) & {
  headers: Headers;
};

export type qualityPacksControllerListQualityPacksResponse = (qualityPacksControllerListQualityPacksResponseSuccess | qualityPacksControllerListQualityPacksResponseError)

export const getQualityPacksControllerListQualityPacksUrl = (partnerId: string,
    params?: QualityPacksControllerListQualityPacksParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/quality-packs?${stringifiedParams}` : `/partners/${partnerId}/quality-packs`
}

export const qualityPacksControllerListQualityPacks = async (partnerId: string,
    params?: QualityPacksControllerListQualityPacksParams, options?: RequestInit): Promise<qualityPacksControllerListQualityPacksResponse> => {
  
  return customFetch<qualityPacksControllerListQualityPacksResponse>(getQualityPacksControllerListQualityPacksUrl(partnerId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getQualityPacksControllerListQualityPacksQueryKey = (partnerId?: string,
    params?: QualityPacksControllerListQualityPacksParams,) => {
    return [
    `/partners/${partnerId}/quality-packs`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getQualityPacksControllerListQualityPacksQueryOptions = <TData = Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError = void>(partnerId: string,
    params?: QualityPacksControllerListQualityPacksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQualityPacksControllerListQualityPacksQueryKey(partnerId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>> = ({ signal }) => qualityPacksControllerListQualityPacks(partnerId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(partnerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type QualityPacksControllerListQualityPacksQueryResult = NonNullable<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>>
export type QualityPacksControllerListQualityPacksQueryError = void


export function useQualityPacksControllerListQualityPacks<TData = Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError = void>(
 partnerId: string,
    params: undefined |  QualityPacksControllerListQualityPacksParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>,
          TError,
          Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerListQualityPacks<TData = Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError = void>(
 partnerId: string,
    params?: QualityPacksControllerListQualityPacksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>,
          TError,
          Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerListQualityPacks<TData = Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError = void>(
 partnerId: string,
    params?: QualityPacksControllerListQualityPacksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List completed quality packs for a partner
 */

export function useQualityPacksControllerListQualityPacks<TData = Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError = void>(
 partnerId: string,
    params?: QualityPacksControllerListQualityPacksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getQualityPacksControllerListQualityPacksQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List completed quality packs for a partner
 */
export const prefetchQualityPacksControllerListQualityPacksQuery = async <TData = Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    params?: QualityPacksControllerListQualityPacksParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getQualityPacksControllerListQualityPacksQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getQualityPacksControllerListQualityPacksSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError = void>(partnerId: string,
    params?: QualityPacksControllerListQualityPacksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQualityPacksControllerListQualityPacksQueryKey(partnerId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>> = ({ signal }) => qualityPacksControllerListQualityPacks(partnerId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type QualityPacksControllerListQualityPacksSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>>
export type QualityPacksControllerListQualityPacksSuspenseQueryError = void


export function useQualityPacksControllerListQualityPacksSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError = void>(
 partnerId: string,
    params: undefined |  QualityPacksControllerListQualityPacksParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerListQualityPacksSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError = void>(
 partnerId: string,
    params?: QualityPacksControllerListQualityPacksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerListQualityPacksSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError = void>(
 partnerId: string,
    params?: QualityPacksControllerListQualityPacksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List completed quality packs for a partner
 */

export function useQualityPacksControllerListQualityPacksSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError = void>(
 partnerId: string,
    params?: QualityPacksControllerListQualityPacksParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListQualityPacks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getQualityPacksControllerListQualityPacksSuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Looks up the partner's work order by its 5-char `work_order_code` (the pin printed on scan labels) and returns the work order UUID. Powers the Quality SPA scan widget's manual-entry fallback. 404s when no active work order matches.
 * @summary Resolve a work order pin code to its work order id
 */
export type qualityPacksControllerResolveByCodeResponse200 = {
  data: ResolveWorkOrderByCodeResponseDto
  status: 200
}

export type qualityPacksControllerResolveByCodeResponse401 = {
  data: void
  status: 401
}

export type qualityPacksControllerResolveByCodeResponse403 = {
  data: void
  status: 403
}

export type qualityPacksControllerResolveByCodeResponse404 = {
  data: void
  status: 404
}
    
export type qualityPacksControllerResolveByCodeResponseSuccess = (qualityPacksControllerResolveByCodeResponse200) & {
  headers: Headers;
};
export type qualityPacksControllerResolveByCodeResponseError = (qualityPacksControllerResolveByCodeResponse401 | qualityPacksControllerResolveByCodeResponse403 | qualityPacksControllerResolveByCodeResponse404) & {
  headers: Headers;
};

export type qualityPacksControllerResolveByCodeResponse = (qualityPacksControllerResolveByCodeResponseSuccess | qualityPacksControllerResolveByCodeResponseError)

export const getQualityPacksControllerResolveByCodeUrl = (partnerId: string,
    params: QualityPacksControllerResolveByCodeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/partners/${partnerId}/quality-packs/resolve-by-code?${stringifiedParams}` : `/partners/${partnerId}/quality-packs/resolve-by-code`
}

export const qualityPacksControllerResolveByCode = async (partnerId: string,
    params: QualityPacksControllerResolveByCodeParams, options?: RequestInit): Promise<qualityPacksControllerResolveByCodeResponse> => {
  
  return customFetch<qualityPacksControllerResolveByCodeResponse>(getQualityPacksControllerResolveByCodeUrl(partnerId,params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getQualityPacksControllerResolveByCodeQueryKey = (partnerId?: string,
    params?: QualityPacksControllerResolveByCodeParams,) => {
    return [
    `/partners/${partnerId}/quality-packs/resolve-by-code`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getQualityPacksControllerResolveByCodeQueryOptions = <TData = Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError = void>(partnerId: string,
    params: QualityPacksControllerResolveByCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQualityPacksControllerResolveByCodeQueryKey(partnerId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>> = ({ signal }) => qualityPacksControllerResolveByCode(partnerId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(partnerId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type QualityPacksControllerResolveByCodeQueryResult = NonNullable<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>>
export type QualityPacksControllerResolveByCodeQueryError = void


export function useQualityPacksControllerResolveByCode<TData = Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError = void>(
 partnerId: string,
    params: QualityPacksControllerResolveByCodeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>,
          TError,
          Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerResolveByCode<TData = Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError = void>(
 partnerId: string,
    params: QualityPacksControllerResolveByCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>,
          TError,
          Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerResolveByCode<TData = Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError = void>(
 partnerId: string,
    params: QualityPacksControllerResolveByCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Resolve a work order pin code to its work order id
 */

export function useQualityPacksControllerResolveByCode<TData = Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError = void>(
 partnerId: string,
    params: QualityPacksControllerResolveByCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getQualityPacksControllerResolveByCodeQueryOptions(partnerId,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Resolve a work order pin code to its work order id
 */
export const prefetchQualityPacksControllerResolveByCodeQuery = async <TData = Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    params: QualityPacksControllerResolveByCodeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getQualityPacksControllerResolveByCodeQueryOptions(partnerId,params,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getQualityPacksControllerResolveByCodeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError = void>(partnerId: string,
    params: QualityPacksControllerResolveByCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQualityPacksControllerResolveByCodeQueryKey(partnerId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>> = ({ signal }) => qualityPacksControllerResolveByCode(partnerId,params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type QualityPacksControllerResolveByCodeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>>
export type QualityPacksControllerResolveByCodeSuspenseQueryError = void


export function useQualityPacksControllerResolveByCodeSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError = void>(
 partnerId: string,
    params: QualityPacksControllerResolveByCodeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerResolveByCodeSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError = void>(
 partnerId: string,
    params: QualityPacksControllerResolveByCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerResolveByCodeSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError = void>(
 partnerId: string,
    params: QualityPacksControllerResolveByCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Resolve a work order pin code to its work order id
 */

export function useQualityPacksControllerResolveByCodeSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError = void>(
 partnerId: string,
    params: QualityPacksControllerResolveByCodeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerResolveByCode>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getQualityPacksControllerResolveByCodeSuspenseQueryOptions(partnerId,params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * A single row of the base.quality_packs view — the same shape and the same check counts the packs grid shows, so the Quality Pack Detail summary cards cannot disagree with the grid. Run Sheet version and project context come from GET work-orders/:work_order_id, which the detail view already has.
 * @summary Get one quality pack summary
 */
export type qualityPacksControllerGetQualityPackResponse200 = {
  data: QualityPackRowDto
  status: 200
}

export type qualityPacksControllerGetQualityPackResponse401 = {
  data: void
  status: 401
}

export type qualityPacksControllerGetQualityPackResponse403 = {
  data: void
  status: 403
}

export type qualityPacksControllerGetQualityPackResponse404 = {
  data: void
  status: 404
}
    
export type qualityPacksControllerGetQualityPackResponseSuccess = (qualityPacksControllerGetQualityPackResponse200) & {
  headers: Headers;
};
export type qualityPacksControllerGetQualityPackResponseError = (qualityPacksControllerGetQualityPackResponse401 | qualityPacksControllerGetQualityPackResponse403 | qualityPacksControllerGetQualityPackResponse404) & {
  headers: Headers;
};

export type qualityPacksControllerGetQualityPackResponse = (qualityPacksControllerGetQualityPackResponseSuccess | qualityPacksControllerGetQualityPackResponseError)

export const getQualityPacksControllerGetQualityPackUrl = (partnerId: string,
    workOrderId: string,) => {


  

  return `/partners/${partnerId}/quality-packs/${workOrderId}`
}

export const qualityPacksControllerGetQualityPack = async (partnerId: string,
    workOrderId: string, options?: RequestInit): Promise<qualityPacksControllerGetQualityPackResponse> => {
  
  return customFetch<qualityPacksControllerGetQualityPackResponse>(getQualityPacksControllerGetQualityPackUrl(partnerId,workOrderId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getQualityPacksControllerGetQualityPackQueryKey = (partnerId?: string,
    workOrderId?: string,) => {
    return [
    `/partners/${partnerId}/quality-packs/${workOrderId}`
    ] as const;
    }

    
export const getQualityPacksControllerGetQualityPackQueryOptions = <TData = Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError = void>(partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQualityPacksControllerGetQualityPackQueryKey(partnerId,workOrderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>> = ({ signal }) => qualityPacksControllerGetQualityPack(partnerId,workOrderId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(partnerId && workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type QualityPacksControllerGetQualityPackQueryResult = NonNullable<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>>
export type QualityPacksControllerGetQualityPackQueryError = void


export function useQualityPacksControllerGetQualityPack<TData = Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError = void>(
 partnerId: string,
    workOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>,
          TError,
          Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerGetQualityPack<TData = Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>,
          TError,
          Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerGetQualityPack<TData = Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get one quality pack summary
 */

export function useQualityPacksControllerGetQualityPack<TData = Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getQualityPacksControllerGetQualityPackQueryOptions(partnerId,workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary Get one quality pack summary
 */
export const prefetchQualityPacksControllerGetQualityPackQuery = async <TData = Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getQualityPacksControllerGetQualityPackQueryOptions(partnerId,workOrderId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getQualityPacksControllerGetQualityPackSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError = void>(partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQualityPacksControllerGetQualityPackQueryKey(partnerId,workOrderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>> = ({ signal }) => qualityPacksControllerGetQualityPack(partnerId,workOrderId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type QualityPacksControllerGetQualityPackSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>>
export type QualityPacksControllerGetQualityPackSuspenseQueryError = void


export function useQualityPacksControllerGetQualityPackSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError = void>(
 partnerId: string,
    workOrderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerGetQualityPackSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerGetQualityPackSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get one quality pack summary
 */

export function useQualityPacksControllerGetQualityPackSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerGetQualityPack>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getQualityPacksControllerGetQualityPackSuspenseQueryOptions(partnerId,workOrderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * The quality-pack detail subtable: every in-process check on the work order, each carrying its in_process_check payload (status, criteria, threshold, and evidence_files for thumbnails).
 * @summary List in-process checks for a work order
 */
export type qualityPacksControllerListChecksResponse200 = {
  data: QualityPackCheckRowDto[]
  status: 200
}

export type qualityPacksControllerListChecksResponse401 = {
  data: void
  status: 401
}

export type qualityPacksControllerListChecksResponse403 = {
  data: void
  status: 403
}
    
export type qualityPacksControllerListChecksResponseSuccess = (qualityPacksControllerListChecksResponse200) & {
  headers: Headers;
};
export type qualityPacksControllerListChecksResponseError = (qualityPacksControllerListChecksResponse401 | qualityPacksControllerListChecksResponse403) & {
  headers: Headers;
};

export type qualityPacksControllerListChecksResponse = (qualityPacksControllerListChecksResponseSuccess | qualityPacksControllerListChecksResponseError)

export const getQualityPacksControllerListChecksUrl = (partnerId: string,
    workOrderId: string,) => {


  

  return `/partners/${partnerId}/quality-packs/${workOrderId}/checks`
}

export const qualityPacksControllerListChecks = async (partnerId: string,
    workOrderId: string, options?: RequestInit): Promise<qualityPacksControllerListChecksResponse> => {
  
  return customFetch<qualityPacksControllerListChecksResponse>(getQualityPacksControllerListChecksUrl(partnerId,workOrderId),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getQualityPacksControllerListChecksQueryKey = (partnerId?: string,
    workOrderId?: string,) => {
    return [
    `/partners/${partnerId}/quality-packs/${workOrderId}/checks`
    ] as const;
    }

    
export const getQualityPacksControllerListChecksQueryOptions = <TData = Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError = void>(partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQualityPacksControllerListChecksQueryKey(partnerId,workOrderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>> = ({ signal }) => qualityPacksControllerListChecks(partnerId,workOrderId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, enabled: !!(partnerId && workOrderId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type QualityPacksControllerListChecksQueryResult = NonNullable<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>>
export type QualityPacksControllerListChecksQueryError = void


export function useQualityPacksControllerListChecks<TData = Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError = void>(
 partnerId: string,
    workOrderId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof qualityPacksControllerListChecks>>,
          TError,
          Awaited<ReturnType<typeof qualityPacksControllerListChecks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerListChecks<TData = Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof qualityPacksControllerListChecks>>,
          TError,
          Awaited<ReturnType<typeof qualityPacksControllerListChecks>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerListChecks<TData = Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List in-process checks for a work order
 */

export function useQualityPacksControllerListChecks<TData = Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getQualityPacksControllerListChecksQueryOptions(partnerId,workOrderId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}

/**
 * @summary List in-process checks for a work order
 */
export const prefetchQualityPacksControllerListChecksQuery = async <TData = Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError = void>(
 queryClient: QueryClient, partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}

  ): Promise<QueryClient> => {

  const queryOptions = getQualityPacksControllerListChecksQueryOptions(partnerId,workOrderId,options)

  await queryClient.prefetchQuery(queryOptions);

  return queryClient;
}



export const getQualityPacksControllerListChecksSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError = void>(partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQualityPacksControllerListChecksQueryKey(partnerId,workOrderId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>> = ({ signal }) => qualityPacksControllerListChecks(partnerId,workOrderId, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type QualityPacksControllerListChecksSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>>
export type QualityPacksControllerListChecksSuspenseQueryError = void


export function useQualityPacksControllerListChecksSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError = void>(
 partnerId: string,
    workOrderId: string, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerListChecksSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQualityPacksControllerListChecksSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary List in-process checks for a work order
 */

export function useQualityPacksControllerListChecksSuspense<TData = Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError = void>(
 partnerId: string,
    workOrderId: string, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof qualityPacksControllerListChecks>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getQualityPacksControllerListChecksSuspenseQueryOptions(partnerId,workOrderId,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Atomically applies a status change to many checks at once. If any targeted check or job card is invalid (e.g. a canceled job card) the whole batch is rejected with a 400 and nothing changes.
 * @summary Bulk-update in-process check statuses
 */
export type qualityPacksControllerBulkUpdateStatusResponse201 = {
  data: BulkCheckStatusResponseDto
  status: 201
}

export type qualityPacksControllerBulkUpdateStatusResponse400 = {
  data: void
  status: 400
}

export type qualityPacksControllerBulkUpdateStatusResponse401 = {
  data: void
  status: 401
}

export type qualityPacksControllerBulkUpdateStatusResponse403 = {
  data: void
  status: 403
}
    
export type qualityPacksControllerBulkUpdateStatusResponseSuccess = (qualityPacksControllerBulkUpdateStatusResponse201) & {
  headers: Headers;
};
export type qualityPacksControllerBulkUpdateStatusResponseError = (qualityPacksControllerBulkUpdateStatusResponse400 | qualityPacksControllerBulkUpdateStatusResponse401 | qualityPacksControllerBulkUpdateStatusResponse403) & {
  headers: Headers;
};

export type qualityPacksControllerBulkUpdateStatusResponse = (qualityPacksControllerBulkUpdateStatusResponseSuccess | qualityPacksControllerBulkUpdateStatusResponseError)

export const getQualityPacksControllerBulkUpdateStatusUrl = (partnerId: string,) => {


  

  return `/partners/${partnerId}/quality-packs/checks/bulk-status`
}

export const qualityPacksControllerBulkUpdateStatus = async (partnerId: string,
    bulkCheckStatusDto: BulkCheckStatusDto, options?: RequestInit): Promise<qualityPacksControllerBulkUpdateStatusResponse> => {
  
  return customFetch<qualityPacksControllerBulkUpdateStatusResponse>(getQualityPacksControllerBulkUpdateStatusUrl(partnerId),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      bulkCheckStatusDto,)
  }
);}




export const getQualityPacksControllerBulkUpdateStatusMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof qualityPacksControllerBulkUpdateStatus>>, TError,{partnerId: string;data: BulkCheckStatusDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof qualityPacksControllerBulkUpdateStatus>>, TError,{partnerId: string;data: BulkCheckStatusDto}, TContext> => {

const mutationKey = ['qualityPacksControllerBulkUpdateStatus'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof qualityPacksControllerBulkUpdateStatus>>, {partnerId: string;data: BulkCheckStatusDto}> = (props) => {
          const {partnerId,data} = props ?? {};

          return  qualityPacksControllerBulkUpdateStatus(partnerId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type QualityPacksControllerBulkUpdateStatusMutationResult = NonNullable<Awaited<ReturnType<typeof qualityPacksControllerBulkUpdateStatus>>>
    export type QualityPacksControllerBulkUpdateStatusMutationBody = BulkCheckStatusDto
    export type QualityPacksControllerBulkUpdateStatusMutationError = void

    /**
 * @summary Bulk-update in-process check statuses
 */
export const useQualityPacksControllerBulkUpdateStatus = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof qualityPacksControllerBulkUpdateStatus>>, TError,{partnerId: string;data: BulkCheckStatusDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof qualityPacksControllerBulkUpdateStatus>>,
        TError,
        {partnerId: string;data: BulkCheckStatusDto},
        TContext
      > => {

      const mutationOptions = getQualityPacksControllerBulkUpdateStatusMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    